import { useRouter } from 'next/router'
import React, { useEffect, useState } from 'react'
import { api } from '../../../utils'
import LoadingSvg from '../../atoms/Loading/Loading'
import OrdineRiepilogoCard from '../../molecules/OrdineRiepilogoCard/OrdineRiepilogoCard'
import FormCheckout from '../../organisms/FormCheckout/FormCheckout'
import FormCheckoutSg from '../../organisms/FormCheckoutSg/FormCheckoutSg'
import Button from '../../atoms/Button/Button'
import { ChevronLeft } from '../../atoms/NewIcons'
import useTrans from '../../../hooks/useTrans'
import CheckoutAlerts from '../../organisms/CheckoutAlerts/CheckoutAlerts'
import NewModal from '../../molecules/NewModal/NewModal'
import * as Sentry from '@sentry/browser'
import { getSafeTranslation } from '../../../utils/safe'

const CheckoutTemplate = ({ service_gift, carrello_main }) => {
  const [ordine, setOrdine] = useState()
  const [isSubmit, setIsSubmit] = useState(false)
  const [isSubmitting, setIsSubmitting] = useState(false)
  const [checkDisponibilitaError, SetCheckDisponibilitaError] = useState(false)
  const [isPromoValida, setPromoValida] = useState(false)
  let router = useRouter()
  const t = useTrans()

  useEffect(() => {
    setPromoValida(
      ordine
        ? ordine?.promozioni_applicate?.length > 0 ||
            ordine?.righe_carrello?.some((riga) => riga.promozioni_applicate?.length > 0)
        : true
    )
  }, [ordine])

  const isValidUrl = (urlString) => {
    try {
      return Boolean(new URL(urlString))
    } catch (e) {
      return false
    }
  }

  const ConfermaOrdine = () => {
    setIsSubmitting(true)
    ordine &&
      api
        .get(`ordini/${ordine.id}/url_pagamento/`, {
          params: {
            lang: router.locale,
          },
        })
        .then((res) => {
          if (isValidUrl(res.data))
            // per forzare refresh in caso di utente guest che richiede creazione account
            window.location.href = res.data
          else {
            document.open()
            document.write(res.data)
            document.close()
          }
        })
        .catch((err) => {
          setIsSubmitting(false)

          if (err.response.data && err.response.data.error) {
            if (err.response.data.error === 'check_disponibilita_failure') {
              SetCheckDisponibilitaError(true)
            }
          }

          Sentry.captureException(err)
        })
  }

  return (
    <div className="w-container">
      <div className="checkout">
        <Button
          href="/cart"
          label={t('Torna al Carrello')}
          variant="ghost"
          size="medium"
          icon={<ChevronLeft />}
          icon_pos="left"
          className="page__back"
        />

        <h1 className="page__title">
          {carrello_main?.step && carrello_main?.step_name
            ? t(`Checkout {0} di {1}: {2}`, [
                carrello_main?.step,
                carrello_main?.steps_count,
                t(...getSafeTranslation(carrello_main?.step_label)),
              ])
            : t('Checkout')}
        </h1>

        <CheckoutAlerts errori={carrello_main?.errori} />

        <div className="checkout__content">
          <div className="checkout__main">
            {carrello_main === undefined ? (
              <LoadingSvg />
            ) : service_gift ? (
              <FormCheckoutSg
                setIsSubmit={setIsSubmit}
                carrello_main={carrello_main}
                pushPayload={setOrdine}
                service_gift={service_gift}
                promoCodeErrorMessage={ordine?.promo_code_error}
                promoCodeAlertMessage={ordine?.promo_code_alert}
              />
            ) : (
              <FormCheckout
                setIsSubmit={setIsSubmit}
                carrello_main={carrello_main}
                pushPayload={setOrdine}
                service_gift={service_gift}
                promoCodeErrorMessage={ordine?.promo_code_error}
                promoCodeAlertMessage={ordine?.promo_code_alert}
              />
            )}
          </div>

          <div className="checkout__sidebar">
            <OrdineRiepilogoCard
              isLoading={isSubmit}
              isCheckout={true}
              isSubmitting={isSubmitting}
              ConfermaOrdine={ConfermaOrdine}
              isOrdine={!!ordine}
              ordine={ordine || carrello_main}
              carrelloCheckout={carrello_main}
              isPromoValida={isPromoValida}
              variant="checkout"
            />
          </div>

          <NewModal
            visible={checkDisponibilitaError}
            alert={true}
            title={t('La quantita di uno o più articoli richiesti non è più disponibile.')}
            actions={[
              <Button
                variant="primary"
                label={t('Torna al carrello')}
                onClick={() => router.push('/cart')}
              />,
            ]}
          />
        </div>
      </div>
    </div>
  )
}

export default CheckoutTemplate
